module.exports = __webpack_public_path__ + "static/assets/e4a18da9cbf9c77f9f0402db81e29a66.png";